export default "__VITE_ASSET__DaMCe40S__"